import { AI_MASTER_FLAG_KEY } from 'utils/aiFeatureFlags';

import useFeatureFlags from './useFeatureFlags';

/**
 * Whether this tenant's AI Workspace modules paint dark. Read from the master flag directly, not
 * from a module's own child flag: the dark surface belongs to the workspace, so every module inside
 * it flips together. PLA-8844.
 */
const useAiDarkMode = (): boolean => {
  const features = useFeatureFlags();

  return features[AI_MASTER_FLAG_KEY] === true;
};

export default useAiDarkMode;
